import UIDs from "../../../../../../UIDs";

const uid = UIDs.screens.admin.composition.aiprompts.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_PROMPT_ASYNC: `${uid}.savePromptAsync`,
    SAVE_PROMPT_SUCCESS: `${uid}.savePromptSuccess`,
    SAVE_PROMPT_FAILURE: `${uid}.savePromptFailure`,
    CREATE_PROMPT: `${uid}.createPrompt`
};

export { ActionTypes };
